import DateFnsUtils from '@date-io/date-fns';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import AddIcon from '@material-ui/icons/Add';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import DeleteIcon from '@material-ui/icons/Delete';
import InfoIcon from '@material-ui/icons/Info';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { Formik } from 'formik';
import { random } from 'lodash';
import MaterialTable from 'material-table';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { trackPromise } from 'react-promise-tracker';
import { useNavigate, useParams } from 'react-router-dom';
import Page from 'src/components/Page';
import { CustomMultiSelect } from 'src/utils/CustomMultiSelect';
import { MaskeliyaBLERPEnum } from 'src/views/Common/MaskeliyaBLERPEnum/MaskeliyaBLERPEnum';
import PageHeader from 'src/views/Common/PageHeader';
import * as Yup from 'yup';
import { LoadingComponent } from 'src/utils/newLoader';
import authService from 'src/utils/permissionAuth';
import tokenService from 'src/utils/tokenDecoder';
import services from 'src/views/GoodReceivedNote/Services';
import AccountEntries from 'src/views/GoodReceivedNote/Pages/AccountEntries';

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100vh',
    padding: theme.spacing(3)
  },
  stepperCard: {
    borderRadius: 16,
    marginBottom: theme.spacing(3),
    background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)'
  },
  formSection: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: 'white',
    boxShadow: '0 2px 12px rgba(15, 76, 117, 0.08)',
    border: '1px solid #e8f0fe'
  },
  inputField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 4,
      transition: 'all 0.2s ease',
      '&:hover': {
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)'
      },
      '&.Mui-focused': {
        boxShadow: '0 2px 6px rgba(25, 118, 210, 0.2)'
      }
    }
  },
  modernButton: {
    borderRadius: 6,
    padding: '8px 20px',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '0.875rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.16)'
    }
  },
  primaryButton: {
    '&:hover': {
      boxShadow: '0 3px 8px rgba(15, 76, 117, 0.3)'
    }
  },
  secondaryButton: {
    backgroundColor: '#f44336',
    color: 'white',
    '&:hover': {
      backgroundColor: '#d32f2f'
    }
  },
  successButton: {
    backgroundColor: '#4caf50',
    color: 'white',
    '&:hover': {
      backgroundColor: '#388e3c'
    }
  },
  tableHeader: {
    background: '#4050B5',
    color: 'white',
    fontWeight: 'bold',
    '& .MuiTableCell-head': {
      color: 'white',
      fontWeight: 600,
      fontSize: '0.9rem',
      padding: '16px 4px',
      whiteSpace: 'nowrap'
    }
  },
  tableRow: {
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: 'rgba(32, 178, 170, 0.04)',
      transform: 'translateX(4px)',
      boxShadow: '0 2px 8px rgba(32, 178, 170, 0.15)'
    }
  },
  amountCell: {
    fontWeight: 700,
    color: '#0f4c75',
    backgroundColor: 'rgba(32, 178, 170, 0.08)',
    borderRadius: 8,
    border: '1px solid rgba(32, 178, 170, 0.2)',
    padding: '8px 12px !important'
  },
  discountCell: {
    fontWeight: 700,
    color: '#d32f2f',
    backgroundColor: 'rgba(211, 47, 47, 0.08)',
    borderRadius: 8,
    border: '1px solid rgba(211, 47, 47, 0.2)',
    padding: '8px 12px !important'
  },
  remainingQtyCell: {
    fontWeight: 700,
    color: '#1e3a8a',
    backgroundColor: 'rgba(30, 58, 138, 0.06)'
  },
  sectionBadge: {
    fontWeight: 600,
    background: '#e3f2fd',
    border: '1px solid #20b2aa',
    color: '#0d47a1',
    borderRadius: 20,
    padding: '8px 16px',
    fontSize: '0.875rem',
    boxShadow: '0 2px 4px rgba(32, 178, 170, 0.2)'
  },
  modernChip: {
    borderRadius: 20,
    fontWeight: 600,
    padding: '8px 16px',
    fontSize: '0.85rem'
  },
  statusChip: {
    background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    color: 'white'
  },
  warningChip: {
    background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    color: 'white'
  },
  infoSection: {
    background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
    borderRadius: 12,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  accordion: {
    borderRadius: 12,
    marginBottom: theme.spacing(1),
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    '&:before': {
      display: 'none'
    }
  },
  dialogPaper: {
    borderRadius: 8,
    padding: theme.spacing(2),
    backgroundColor: '#ffffff'
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  dialogIcon: {
    backgroundColor: '#e0e7ff',
    color: '#3730a3',
    width: 36,
    height: 36
  },
  summarySection: {
    backgroundColor: '#f5f5f5',
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  iconButton: {
    borderRadius: 12,
    padding: 12,
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'scale(1.1)',
      backgroundColor: 'rgba(103, 126, 234, 0.1)'
    }
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  tableHeaderPGRN: {
    backgroundColor: '#8ea9fa',
    color: '#000',
    fontWeight: 'bold'
  },
  tableCell: {
    fontWeight: 'bold',
    color: theme.palette.common.white
  },
  tableCell: {
    fontWeight: 'bold',
    color: theme.palette.common.white
  },
  actionCell: {
    transition: 'max-width 0.4s ease, padding 0.4s ease, opacity 0.4s ease-out',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    padding: '0 !important',
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
  actionCellHidden: {
    maxWidth: '0px',
    opacity: 0,
    borderLeftColor: 'transparent',
  },
  actionCellVisible: {
    maxWidth: '250px',
    opacity: 1,
    padding: `${theme.spacing(1)}px !important`,
  },
  actionQtyField: {
    minWidth: '120px',
    '& input': {
      textAlign: 'right'
    }
  },
}));

const screenCode = 'GOODRECEIVEDNOTE';

const formatNumberWithThousandSeparators = input => {
  let value = String(input).replace(/[^0-9.]/g, '');
  const parts = value.split('.');
  if (parts.length > 1) {
    parts[1] = parts[1].slice(0, 2);
    value = parts[0] + (parts[1] ? `.${parts[1]}` : '');
  }
  const formattedInteger = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return formattedInteger + (parts.length > 1 ? `.${parts[1]}` : '');
};

const oneKeyDownAddDecimal = e => {
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
  if (e.key === '.' && e.target.value.includes('.')) {
    e.preventDefault();
  }
  if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key) && e.key !== '.') {
    e.preventDefault();
  }
};

export default function GoodReceiveNoteAddEdit() {
  const { goodsReceiveNoteID } = useParams();
  const [title, setTitle] = useState('Goods Received Note');
  const navigate = useNavigate();
  const alert = useAlert();
  const classes = useStyles();
  const maskeliyaBLERPEnum = new MaskeliyaBLERPEnum();
  const [groups, setGroups] = useState([]);
  const [codes, setCodes] = useState([]);
  const [dpoNumber, setDpoNumber] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [isEditIcon, setIsEditIcon] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState('');
  const [dialogAction, setDialogAction] = useState(null);
  const [gtnNumber, setGtnNumber] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [purchaseOrder, setPurchaseOrder] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [transactionsByRequisition, setTransactionsByRequisition] = useState([]);
  const [variance, setVariance] = useState(0);
  const [refNo, setRefNo] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [actions, setActions] = useState([]);
  const [requisitions, setRequisitions] = useState([]);
  const [ledgerAccountsByRequisition, setLedgerAccountsByRequisition] = useState({});
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [TempValu, setTempValu] = useState({
    purchaseOrderID: 0,
    purchaseOrderNumber: ''
  });
  const [goodsReceiveNote, setGoodsReceiveNote] = useState({
    groupID: 0,
    factoryID: 0,
    receivedDate: moment(new Date()).format('YYYY-MM-DD'),
    grnType: 0,
    requisitionID: 0,
    purchaseNumberID: 0,
    invoiceNumber: '',
    invoiceDate: moment(new Date()).format('YYYY-MM-DD'),
    paymentDueDate: moment(new Date()).format('YYYY-MM-DD'),
    isCredit: false,
    gtnNumberID: 0,
    warehouseID: 0,
    actionType: 0,
    dpoNumberID: 0
  });
  const [dpoData, setDpoData] = useState([]);
  const [minInvoiceDate, setMinInvoiceDate] = useState(new Date('1900-01-01'));
  const [vatAccount, setVatAccount] = useState(null);
  const PO = maskeliyaBLERPEnum.GoodReceivedNoteStatusGRNType.PurchaseOrder;
  const DGRN = maskeliyaBLERPEnum.GoodReceivedNoteStatusGRNType.DirectGRN;
  const DPO = maskeliyaBLERPEnum.GoodReceivedNoteStatusGRNType.DirectPurchaseOrder;

  const getOptionLabel = option => `${option.label}`;
  const getOptionDisabled = option => option.value === 'foo';
  const handleToggleOption = selectedOptions =>
    setSelectedOptions(selectedOptions);
  const handleClearOptions = () => setSelectedOptions([]);
  const handleSelectAll = isSelected => {
    if (isSelected) {
      setSelectedOptions(requisitions);
    } else {
      handleClearOptions();
    }
  };

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
    trackPromise(getActionTypeForDropDown());
    let decrypted = 0;
    decrypted = atob(goodsReceiveNoteID);
    if (decrypted !== '0') {
      setIsUpdate(true);
      setGoodsReceiveNote({ ...goodsReceiveNote, grnType: decrypted });
      trackPromise(getGoodsReceiveNoteDetails());
    }
  }, []);

  useEffect(() => {
    if (goodsReceiveNote.groupID !== 0) {
      trackPromise(getFactoriesForDropdown());
      setInvoiceNumber('');
    }
  }, [goodsReceiveNote.groupID]);

  useEffect(() => {
    if (goodsReceiveNote.factoryID !== 0) {
      trackPromise(getGroupCodeAndFactoryCode());
      trackPromise(getVATAccount());
    }
  }, [goodsReceiveNote.factoryID]);

  useEffect(() => {
    if (codes?.gfCode) {
      trackPromise(getReferenceNumber());
    }
  }, [codes]);

  useEffect(() => {
    if (goodsReceiveNote.grnType === PO && goodsReceiveNote.factoryID !== 0) {
      trackPromise(getPurchaseOrderListing(goodsReceiveNote.factoryID));
    }
  }, [goodsReceiveNote.grnType, goodsReceiveNote.factoryID]);

  useEffect(() => {
    if (goodsReceiveNote.purchaseNumberID !== 0) {
      trackPromise(getRequisitionNumberForDropDown());
    }
  }, [goodsReceiveNote.purchaseNumberID]);

  useEffect(() => {
    if (
      goodsReceiveNote.grnType !== PO &&
      goodsReceiveNote.groupID !== 0 &&
      goodsReceiveNote.factoryID !== 0
    ) {
      trackPromise(GetWarehousesByGroupIDAndFactoryID());
    }
  }, [
    goodsReceiveNote.groupID,
    goodsReceiveNote.factoryID,
    goodsReceiveNote.grnType
  ]);
  useEffect(() => {
    if (
      goodsReceiveNote.grnType === DPO &&
      goodsReceiveNote.groupID !== 0 &&
      goodsReceiveNote.factoryID !== 0
    ) {
      trackPromise(GetDirectPurchaseOrderNumbersForDropDown());
    }
  }, [
    goodsReceiveNote.groupID,
    goodsReceiveNote.factoryID,
    goodsReceiveNote.grnType
  ]);

  useEffect(() => {
    setTitle(getTitleByGRNType(goodsReceiveNote.grnType));
  }, [goodsReceiveNote.grnType]);

  useEffect(() => {
    const totalNetAmount = tableData.reduce((total, requisition) => {
      return (
        total +
        requisition.items.reduce(
          (subTotal, item) => subTotal + (parseFloat(item.netAmount) || 0),
          0
        )
      );
    }, 0);
    setGoodsReceiveNote(prevState => ({
      ...prevState,
      netAmount: totalNetAmount.toFixed(2)
    }));
  }, [tableData]);

  useEffect(() => {
    if (goodsReceiveNote.grnType === DGRN) {
      const dgrnTotal = tableData.reduce((sum, req) => {
        return (
          sum +
          req.items.reduce((itemSum, it) => {
            const qty = parseFloat(it.receivedQTY) || 0;
            const price = parseFloat(it.unitPrice) || 0;
            const addCost = parseFloat(it.cost) || 0;
            return itemSum + (qty * price + addCost);
          }, 0)
        );
      }, 0);
    }
  }, [tableData, goodsReceiveNote.grnType]);

  async function getPermission() {
    const permissions = await authService.getPermissionsByScreen(screenCode);
    const isAuthorized = permissions.find(
      p => p.permissionCode === 'ADDEDITGOODRECEIVEDNOTE'
    );
    if (!isAuthorized) {
      navigate('/404');
    }
    const isGroupFilterEnabled = permissions.find(
      p => p.permissionCode === 'GROUPDROPDOWN'
    );
    const isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode === 'FACTORYDROPDOWN'
    );

    setPermissions({
      isGroupFilterEnabled: !!isGroupFilterEnabled,
      isFactoryFilterEnabled: !!isFactoryFilterEnabled
    });

    setGoodsReceiveNote(prev => ({
      ...prev,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    }));
  }

  const getTitleByGRNType = grnType => {
    switch (grnType) {
      case PO:
        return 'Goods Received Note - Purchase Order';
      case DGRN:
        return 'Goods Received Note - Direct GRN';
      case DPO:
        return 'Goods Received Note - Direct Purchase Order';
      default:
        return 'Goods Received Note';
    }
  };

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getGroupCodeAndFactoryCode() {
    const codes = await services.getGroupCodeAndFactoryCode(
      goodsReceiveNote.groupID,
      goodsReceiveNote.factoryID
    );
    setCodes(codes);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(
      goodsReceiveNote.groupID
    );
    setFactoryList(factories);
  }

  async function GetWarehousesByGroupIDAndFactoryID() {
    var res = await services.GetWarehousesByGroupIDAndFactoryID(
      goodsReceiveNote.groupID,
      goodsReceiveNote.factoryID
    );
    setWarehouse(res);
  }

  async function getPurchaseOrderListing() {
    const list = await services.getPurchaseOrderListing(
      goodsReceiveNote.factoryID
    );
    setPurchaseOrder(list);
  }

  async function GetDirectPurchaseOrderNumbersForDropDown() {
    const response = await services.getDirectPurchaseOrderNumbersForListingDropDown(goodsReceiveNote.groupID, goodsReceiveNote.factoryID);
    setDpoData(response);
    let actionTypes = [];
    for (let item of Object.entries(response)) {
      actionTypes[item[1]["directPurchaseOrderID"]] = item[1]["dpoNumber"];
    }
    setDpoNumber(actionTypes);
  }

  async function getActionTypeForDropDown() {
    const response = await services.getActionTypeForDropDown();
    setActions(response);
  }

  async function getRequisitionNumberForDropDown() {
    var response = await services.getRequisitionNumberForDropDown(
      goodsReceiveNote.purchaseNumberID
    );
    var newCollectionTypeArray = [];
    for (var i = 0; i < response.length; i++) {
      newCollectionTypeArray.push({
        label: response[i].requisitionNumber,
        value: response[i].requisitionID
      });
    }
    setRequisitions(newCollectionTypeArray);
  }

  const requisitionIDs = selectedOptions.map(option => parseInt(option.value));

  async function getVATAccount() {
    let account = await services.GetVATAccountForGRN(goodsReceiveNote.factoryID);

    if (Array.isArray(account)) {
      account = account.length > 0 ? account[0] : null;
    }

    if (account) {
      const normalizedAccount = {
        ledgerAccountID: account.ledgerAccountID,
        ledgerAccountName: account.ledgerAccountName,
        parentTransactionModeID: account.parentTransactionModeID,
        childHeaderID: account.childHeaderID,
      };
      setVatAccount(normalizedAccount);
    } else {
      setVatAccount(null);
    }
  }

  async function getGoodsReceiveNoteDetails() {
    const requisitionIDsParam = requisitionIDs.join(',');
    let model = {};
    if (goodsReceiveNote.grnType === PO) {
      model = {
        groupID: parseInt(goodsReceiveNote.groupID),
        factoryID: parseInt(goodsReceiveNote.factoryID),
        grnTypeID: parseInt(goodsReceiveNote.grnType),
        purchaseNumberID: parseInt(goodsReceiveNote.purchaseNumberID),
        requisitionIDs: requisitionIDsParam
      };
    } else if (goodsReceiveNote.grnType === DGRN) {
      model = {
        groupID: parseInt(goodsReceiveNote.groupID),
        factoryID: parseInt(goodsReceiveNote.factoryID),
        grnTypeID: parseInt(goodsReceiveNote.grnType),
        gtnNumberID: parseInt(goodsReceiveNote.gtnNumberID)
      };
    } else if (goodsReceiveNote.grnType === DPO) {
      model = {
        groupID: parseInt(goodsReceiveNote.groupID),
        factoryID: parseInt(goodsReceiveNote.factoryID),
        grnTypeID: parseInt(goodsReceiveNote.grnType),
        directPurchaseOrderID: parseInt(goodsReceiveNote.dpoNumberID)
      };
    }

    const response = await services.getGoodsReceiveNoteDetails(model);
    if ((response.data?.pendingGRNDetails?.length > 0) || (response.data?.partiallyCompleteGRNDetails?.length > 0)) {
      const formattedData = Object.values(
        response.data.pendingGRNDetails.reduce((acc, item) => {
          const key = item.requisitionNumber || item.dpoNumber;
          if (!acc[key]) {
            acc[key] = {
              requisitionNumber: item.requisitionNumber,
              dpoNumber: item.dpoNumber,
              poNumber: item.purchaseOrderNumber,
              directGrnNumber: item.directGrnNumber,
              items: []
            };
          }
          acc[key].items.push({
            budgetCodeID: item.budgetCodeID,
            sku: item.skuMasterName,
            requestedQTYByRequisition: item.requestedQTYByRequisition,
            purchaseOrderDetailsID: item.purchaseOrderDetailsID,
            requestedQTY: item.requestedQTY,
            receivedQTY: item.requestedQTY,
            actionQty: item.requestedQTY,
            actionType: '1',
            netAmount: item.netAmount,
            qcStatus: false,
            expanded: false,
            additionalData: [],
            skuMasterID: item.skuMasterID,
            skuCode: item.skuMasterCode,
            itemCategoryID: item.skuCategoryID,
            skuWarehouseID: item.warehouseID,
            warehouseSKUMappingID: item.warehouseSKUMappingID,
            requisitionWarehouseID: item.requisitionWarehouseID,
            toWarehouseID: item.deliveryWarehouseID,
            fromWarehouseID: item.fromWarehouseID,
            requisitionID: item.requisitionID,
            supplierID: item.supplierID,
            supplierName: item.supplierName,
            unitPrice: item.unitPrice,
            qUnitPrice: item.qUnitPrice,
            discountAmount: item.discountAmount,
            vatAmount: item.vatAmount,
            remainingQty: 0,
            totalAmount: (
              item.poUnitPrice *
              item.requestedQTY *
              (1 - item.discountAmount / 100)
            ).toFixed(2)
          });
          return acc;
        }, {})
      );

      // const partiallyGRNedItems = Object.values(
      //   response.data.partiallyCompleteGRNDetails?.reduce((acc, item) => {
      //     const key = item.grnNumber;
      //     if (!acc[key]) {
      //       acc[key] = {
      //         requisitionNumber: item.requisitionNumber || '',
      //         dpoNumber: item.dpoNumber || '',
      //         groupID: item.groupID,
      //         factoryID: item.factoryID,
      //         grnNumber: item.grnNumber,
      //         grnTypeID: item.grnTypeID,
      //         purchaseNumberID: item.purchaseNumberID,
      //         invoiceDate: item.invoiceDate ? new Date(item.invoiceDate) : null,
      //         invoiceNumber: item.invoiceNumber || '',
      //         isCredit: item.isCredit || false,
      //         netAmount: item.netAmount || 0,
      //         grossAmount: item.grossAmount || 0,
      //         paymentDueDate: item.paymentDueDate
      //           ? new Date(item.paymentDueDate)
      //           : null,
      //         items: item.items || []
      //       };
      //     }
      //     return acc;
      //   }, {}) || {}
      // );
      const recalculated = formattedData.map(req => ({
        ...req,
        items: req.items.map(it => ({
          ...it,
          netAmount: (
            parseFloat(it.unitPrice || 0) * parseFloat(it.receivedQTY || 0) -
            parseFloat(it.discountAmount || 0) + parseFloat(it.vatAmount || 0)
          ).toFixed(2),
          cost: parseFloat(it.cost || 0)
        }))
      }));

      setTableData(recalculated);
      await fetchLedgerAccountsForTableData(recalculated);
    } else {
      alert.error('No Records Found');
    }
  }

  const fetchLedgerAccountsForTableData = async formattedData => {
    const result = {};
    const requisitionList = Object.entries(formattedData);
    for (let i = 0; i < requisitionList.length; i++) {
      const [key, requisition] = requisitionList[i];
      const firstItem = requisition.items[0];

      if (firstItem?.budgetCodeID) {
        const account = await services.getLedgerAccountByBudgetCodeID(
          firstItem.budgetCodeID,
          goodsReceiveNote.factoryID
        );
        result[i] = account;
      }
    }
    setLedgerAccountsByRequisition(result);
  };

  async function saveGRN() {
    setIsSubmitting(true);
    try {
      for (let i = 0; i < tableData.length; i++) {
        const requisition = tableData[i];

        const hasPendingQty = requisition.items.some(
          item => item.requestedQTY - item.receivedQTY > 0
        );

        const commonModelData = {
          createdBy: tokenService.getUserIDFromToken(),
          description: '',
          factoryID: goodsReceiveNote.factoryID,
          fromWarehouseID: requisition.items[0]?.fromWarehouseID || 0,
          grnType: goodsReceiveNote.grnType,
          inReference:
            goodsReceiveNote.grnType === PO
              ? requisition.poNumber
              : goodsReceiveNote.grnType === DGRN
                ? requisition.directGrnNumber
                : requisition.dpoNumber,
          groupID: goodsReceiveNote.groupID,
          gtnNumberID: goodsReceiveNote.gtnNumberID,
          invoiceDate: new Date(goodsReceiveNote.invoiceDate).toISOString(),
          invoiceNumber: goodsReceiveNote.invoiceNumber,
          isCredit: goodsReceiveNote.isCredit,
          itemCategoryID: requisition.items[0]?.itemCategoryID,
          itemList: requisition.items.map(item => {
            const additionalData = Array.isArray(item.additionalData)
              ? item.additionalData
              : [];
            const remainingQty =
              item.receivedQTY -
              (item.actionQty || 0) -
              additionalData.reduce((sum, data) => sum + data.qty, 0);
            const List = additionalData.map(data => ({
              actionType: data.type || 1,
              qty: data.qty
            }));
            return {
              inReference: requisition.poNumber,
              skuMasterID: item.skuMasterID || 0,
              additionalCost: item.cost || 0,
              netAmount: item.netAmount || 0,
              unitPrice: item.unitPrice || 0,
              receivedQTY: item.receivedQTY || 0,
              skuMasterCode: item.skuCode || '',
              actionQty: item.actionQty || 0,
              remainingQty,
              qcStatus: item.qcStatus || false,
              warehouseSKUMappingID: item.warehouseSKUMappingID || 0,
              itemCategoryID: item.skuCategoryID || 0,
              List: List.length > 0 ? List : []
            };
          }),
          supplierInvoiceDetails: {
            groupID: goodsReceiveNote.groupID,
            factoryID: goodsReceiveNote.factoryID,
            invoiceDate: new Date(goodsReceiveNote.invoiceDate).toISOString(),
            invoiceNumber: goodsReceiveNote.invoiceNumber,
            isCredit: goodsReceiveNote.isCredit,
            netAmount: goodsReceiveNote.netAmount,
            grossAmount: goodsReceiveNote.grossAmount,
            paymentDueDate: goodsReceiveNote.isCredit
              ? new Date(goodsReceiveNote.paymentDueDate).toISOString()
              : null,
            createdBy: tokenService.getUserIDFromToken()
          },
          noOfSku: requisition.items.length,
          noOfUnits: requisition.items.length,
          paymentDueDate: goodsReceiveNote.isCredit
            ? new Date(goodsReceiveNote.paymentDueDate).toISOString()
            : null,
          purchaseNumberID: goodsReceiveNote.grnType == 2 ? goodsReceiveNote.purchaseNumberID : goodsReceiveNote.dpoNumberID,
          quotationHeaderID: requisition.items[0]?.quotationHeaderID || 0,
          receivedDate: new Date(goodsReceiveNote.receivedDate).toISOString(),
          requisitionID: requisition.items[0]?.requisitionID,
          statusID: goodsReceiveNote.grnType == PO ? 2 : goodsReceiveNote.grnType == DPO ? 3 : 1,
          supplierID: requisition.items[0]?.supplierID,
          toWarehouseID: requisition.items[0]?.requisitionWarehouseID || 0
        };

        const approveList = {
          grnStatusID: hasPendingQty ? 3 : 4,
          purchaseOrderID: goodsReceiveNote.grnType == 2 ? goodsReceiveNote.purchaseNumberID : goodsReceiveNote.dpoNumberID
        };

        const keepListModel = {
          ...commonModelData,
          transactionTypeID: goodsReceiveNote.grnType == 3 ? 5 : 1,
          referenceTypeID: 1,
          referenceType: 'In',
          itemList: commonModelData.itemList
            .map(item => ({
              ...item,
              List: item.List.filter(data => [1, 4, 3].includes(data.actionType))
              // actionType 1 = Accept
              // actionType 4 = Damaged  
              // actionType 3 = Expired
            }))
            .filter(item => item.List.length > 0),
          approveList: {
            ...approveList,
            poApprovalList: requisition.items.map(item => {
              const remainingQty = item.requestedQTY - item.receivedQTY;
              return {
                purchaseOrderDetailID: item.purchaseOrderDetailsID,
                skuMasterID: item.skuMasterID || 0,
                remainingQuantity: remainingQty
              };
            })
          }
        };

        const returnListModel = {
          ...commonModelData,
          transactionTypeID: 4,
          referenceTypeID: 2,
          referenceType: 'Out',
          itemList: commonModelData.itemList
            .map(item => ({
              ...item,
              List: item.List.filter(data => data.actionType === 2)
              // actionType 2 = Return
            }))
            .filter(item => item.List.length > 0),
          approveList: {
            ...approveList,
            poApprovalList: requisition.items.map(item => {
              const remainingQty = item.requestedQTY - item.receivedQTY;
              return {
                purchaseOrderDetailID: item.purchaseOrderDetailsID,
                skuMasterID: item.skuMasterID || 0,
                remainingQuantity: remainingQty
              };
            })
          }
        };

        const result = [keepListModel, returnListModel].filter(
          model => model.itemList.length > 0
        );

        let ledgerModel = null;
        let isAccountPayable = false;
        const currentTransactions = transactionsByRequisition[i];

        if (currentTransactions) {
          let localJournalData = [];
          const parentTransactionModeID = currentTransactions.entries.find(x => x.parentTransactionModeID > 0)?.parentTransactionModeID || 0;

          if (goodsReceiveNote.isCredit == false || goodsReceiveNote.grnType == 1) {
            currentTransactions.entries.forEach(x => {
              if (parseFloat(x.credit) > 0) {
                localJournalData.push({
                  accountTypeName: x.ledgerAccountID,
                  credit: x.credit,
                  debit: 0,
                  description: x.description,
                  descriptionTypeID: 0,
                  disableCreditField: false,
                  disableDebitField: true,
                  ledgerTransactionID: 0,
                  rowID: random(1, 1000000),
                  ledgerAccountName: x.ledgerAccount,
                  parentTransactionModeID: x.parentTransactionModeID || 0
                });
              } else {
                localJournalData.push({
                  accountTypeName: x.ledgerAccountID,
                  debit: x.debit,
                  credit: 0,
                  description: x.description,
                  descriptionTypeID: 0,
                  disableCreditField: true,
                  disableDebitField: false,
                  ledgerTransactionID: 0,
                  rowID: random(1, 1000000),
                  ledgerAccountName: x.ledgerAccount,
                  parentTransactionModeID: x.parentTransactionModeID || 0
                });
              }
            });

            ledgerModel = {
              groupID: goodsReceiveNote.groupID,
              factoryID: goodsReceiveNote.factoryID,
              transactionTypeID: parentTransactionModeID,
              referenceNumber: refNo,
              referenceNumberInter: '',
              chequeNumber: '',
              voucherType: 1, // Payment
              transactionMode: 0,
              voucherCode: 'GR',
              recipientName: '',
              isActive: true,
              journalData: localJournalData,
              date: goodsReceiveNote.invoiceDate,
              dueDate: goodsReceiveNote.paymentDueDate,
              interEstateID: 0,
              isInterEstate: false,
              supplierID: 0,
              tranLedgerAccountID: 0,
              status: 1,
              modeoftransaction: 1,
              modeoftransactionNumber: '',
              payee: '',
              createdBy: tokenService.getUserIDFromToken()
            };
            isAccountPayable = false;
          } else {
            currentTransactions.entries.forEach(x => {
              if (parseFloat(x.credit) > 0) {
                localJournalData.push({
                  accountTypeName: x.ledgerAccountID,
                  credit: x.credit,
                  debit: 0,
                  description: x.description,
                  descriptionTypeID: 0,
                  ledgerTransactionID: 0,
                  ledgerAccountName: x.ledgerAccount,
                  parentTransactionModeID: x.parentTransactionModeID || 0
                });
              } else {
                localJournalData.push({
                  accountTypeName: x.ledgerAccountID,
                  debit: x.debit,
                  credit: 0,
                  description: x.description,
                  descriptionTypeID: 0,
                  ledgerTransactionID: 0,
                  ledgerAccountName: x.ledgerAccount,
                  parentTransactionModeID: x.parentTransactionModeID || 0
                });
              }
            });

            ledgerModel = {
              groupID: goodsReceiveNote.groupID,
              factoryID: goodsReceiveNote.factoryID,
              transactionTypeID: parentTransactionModeID,
              referenceNumber: refNo,
              referenceNumberInter: '',
              chequeNumber: '',
              voucherType: 4, //Account Payable
              transactionMode: 2, //Inventory GRN
              transactionModeName: 'Inventory GRN',
              voucherCode: 'GR',
              recipientName: '',
              isActive: true,
              journalData: localJournalData,
              transactionDate: moment(new Date()).format('YYYY-MM-DD'),
              invoiceNo: goodsReceiveNote.invoiceNumber,
              invoiceDate: new Date(goodsReceiveNote.invoiceDate).toISOString(),
              date: moment(new Date()).format('YYYY-MM-DD'),
              dueDate: moment(new Date()).format('YYYY-MM-DD'),
              status: parseInt(2),
              interEstateID: 0,
              isInterEstate: false,
              payableReferenceNumber: invoiceNumber,
              supplierID: requisition.items[0]?.supplierID,
              supplierName:
                requisition.items[0]?.supplierName == 0
                  ? ''
                  : requisition.items[0]?.supplierName,
              payableDescription: '',
              tranLedgerAccountID: localJournalData.find(x => x.credit > 0)?.accountTypeName || 0,
              tranLedgerAccountName: localJournalData.find(x => x.credit > 0)?.ledgerAccountName || '',
              createdBy: tokenService.getUserIDFromToken()
            };
            isAccountPayable = true;
          }
        }

        const compositeModel = {
          grnDetails: result,
          generalJournalDetails: !isAccountPayable ? ledgerModel : null,
          accountPayableDetails: isAccountPayable ? ledgerModel : null,
          isAccountPayable: isAccountPayable
        };

        const response = await services.saveGoodsReceivedNoteWithLedger(compositeModel);

        if (response.statusCode != 'Success') {
          alert.error(response.message);
          setIsSubmitting(false);
          return;
        }
      }
      setIsSubmitting(false);

      alert.success('All Goods Receive Notes saved successfully');
      clearFormFields();
      handleDialogClose();
      setTableData([]);
      setGoodsReceiveNote({
        groupID: 0,
        factoryID: 0,
        invoiceDate: moment(new Date()).format('YYYY-MM-DD'),
        invoiceNumber: '',
        isCredit: false
      });
    } catch (error) {
      alert.error('An error occurred while saving');
      setIsSubmitting(false);
    }
  }

  async function getReferenceNumber() {
    let refModel = {
      groupID: goodsReceiveNote.groupID,
      factoryID: goodsReceiveNote.factoryID,
      date: moment(new Date()).format('YYYY-MM-DD'),
      voucherCode: 'GR',
      ledgerAccountTRCode: 'GRN'
    };
    const ref = await services.getReferenceNumber(refModel);
    const originalRef = ref.data;
    const segments = originalRef.split('/'); // ["GR", "2526", "GRN", "00001"]

    // if (segments.length == 4 && codes.gfCode) {
    //   const updatedRef = [
    //     "REF",
    //     segments[1],
    //     segments[2],
    //     codes.gfCode,
    //     segments[3]
    //   ].join("/");
    if (segments.length === 4 && codes.gfCode) {
      const updatedRef = 'GRN' + segments[1] + codes.gfCode + segments[3];

      setInvoiceNumber(updatedRef);
    }
    setRefNo(ref.data);
  }

  function generateDropDownMenu(data) {
    if (!data) return [];
    return Object.entries(data).map(([key, value]) => {
      const valueString = String(value);
      const lastPart = valueString.split('/').pop();
      return (
        <MenuItem key={key} value={key}>
          {lastPart}
        </MenuItem>
      );
    });
  }

  const getGroupNameById = groupID => {
    if (!groups || !groupID) return '-';
    const groupName = groups[groupID];
    if (groupName) {
      return groupName.split('/').pop();
    }
    return '-';
  };

  function handleChange(e) {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === 'grnType') {
      setTableData([]);
      setSelectedOptions([]);
      setRequisitions([]);
      setTempValu([]);
      setGoodsReceiveNote({
        ...goodsReceiveNote,
        [name]: formattedValue,
        purchaseNumberID: 0,
        requisitionID: 0,
        warehouseID: 0,
        dpoNumberID: 0,
        gtnNumberID: 0,
        receivedDate: moment(new Date()).format('YYYY-MM-DD'),
        invoiceNumber: '',
        invoiceDate: moment(new Date()).format('YYYY-MM-DD'),
        paymentDueDate: moment(new Date()).format('YYYY-MM-DD'),
        gtnNumberID: 0
      });
    } else if (name === 'factoryID') {
      setTableData([]);
      setSelectedOptions([]);
      setRequisitions([]);
      setTempValu([]);
      setGoodsReceiveNote({
        ...goodsReceiveNote,
        [name]: formattedValue,
        grnType: 0,
        receivedDate: moment(new Date()).format('YYYY-MM-DD'),
        purchaseNumberID: 0,
        requisitionID: 0,
        invoiceNumber: '',
        invoiceDate: moment(new Date()).format('YYYY-MM-DD'),
        paymentDueDate: moment(new Date()).format('YYYY-MM-DD'),
        gtnNumberID: 0
      });
    } else if (name === 'dpoNumberID' || name === 'requisitionID' || name === 'gtnNumberID') {
      if (name === 'dpoNumberID') {
        if (dpoData && Array.isArray(dpoData)) {
          const selectedDPO = dpoData.find(d => d.directPurchaseOrderID == value);
          if (selectedDPO) {
            setMinInvoiceDate(selectedDPO.createdDate);
          }
        }
      }
      setTableData([]);
      setRequisitions([]);
      setTempValu([]);
      setGoodsReceiveNote({
        ...goodsReceiveNote,
        [name]: formattedValue,
        receivedDate: moment(new Date()).format('YYYY-MM-DD'),
        purchaseNumberID: 0,
        invoiceNumber: '',
        invoiceDate: moment(new Date()).format('YYYY-MM-DD'),
        paymentDueDate: moment(new Date()).format('YYYY-MM-DD'),
      });
    } else if (name === 'purchaseOrderID' || name === 'warehouseID') {
      setTableData([]);
      setRequisitions([]);
      setTempValu([]);
      setSelectedOptions([]);
      setGoodsReceiveNote({
        ...goodsReceiveNote,
        [name]: formattedValue,
        receivedDate: moment(new Date()).format('YYYY-MM-DD'),
        purchaseNumberID: 0,
        requisitionID: 0,
        gtnNumberID: 0,
        invoiceNumber: '',
        invoiceDate: moment(new Date()).format('YYYY-MM-DD'),
        paymentDueDate: moment(new Date()).format('YYYY-MM-DD'),
      });
    } else {
      setSelectedOptions([]);
      setGoodsReceiveNote(prevState => ({
        ...prevState,
        [name]: formattedValue || ''
      }));
    }
  }

  function handleDateChange(name, date) {
    if (!date || isNaN(new Date(date).getTime())) {
      alert.error('Invalid date selected');
      return;
    }
    setGoodsReceiveNote(prevState => ({
      ...prevState,
      [name]: moment(date).format('YYYY-MM-DD')
    }));
  }

  function handleSwitchChange(e) {
    const { name, checked } = e.target;
    setGoodsReceiveNote(prevState => ({
      ...prevState,
      [name]: checked
    }));
    getGoodsReceiveNoteDetails();
  }

  const handleDialogOpen = (content, action) => {
    setDialogContent(content);
    setDialogAction(() => action);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setIsCancel(false);
  };

  const handleCancel = () => {
    setIsCancel(true);
    handleDialogOpen('Are you sure you want to cancel?', () => {
      handleDialogClose();
      clearFormFields();
      setTableData([]);
    });
  };

  const handleSave = async () => {
    if (tableData[0]?.items[0]?.additionalData.length <= 0) {
      alert.error('Please add data before saving');
      return;
    }
    else if (goodsReceiveNote.grnType === PO || goodsReceiveNote.grnType === DPO || goodsReceiveNote.grnType === DGRN) {
      if (
        (transactionsByRequisition.length !== tableData.length && tableData[0]?.items[0]?.actionType === '1')
      ) {
        alert.error('Please enter entries for all requisitions before saving.');
        return;
      }
    }

    if (variance !== 0) {
      alert.error('Variance between Credit and Debit');
      return;
    }

    if (goodsReceiveNote.grnType === PO || goodsReceiveNote.grnType === DPO) {
      const quantitiesFullyReceived = tableData.every(requisition =>
        requisition.items.every(
          item =>
            parseFloat(item.receivedQTY) === parseFloat(item.requestedQTY)
        )
      );

      if (!quantitiesFullyReceived) {
        alert.error(
          'Remaining quantity must be 0 before saving.'
        );
        return;
      }
    }

    handleDialogOpen('Would you like to proceed with saving this GRN?', saveGRN);
  };

  function clearFormFields() {
    setIsCancel(false);
    setGoodsReceiveNote({
      groupID: goodsReceiveNote.groupID,
      factoryID: goodsReceiveNote.factoryID,
      requisitionID: 0,
      grnType: 0,
      purchaseNumberID: 0,
      invoiceNumber: '',
      invoiceDate: moment(new Date()).format('YYYY-MM-DD'),
      paymentDueDate: moment(new Date()).format('YYYY-MM-DD'),
      receivedDate: moment(new Date()).format('YYYY-MM-DD'),
      isCredit: true,
      gtnNumberID: 0
    });
    setTableData([]);
  }

  function handleSearchDropdownPONumber(data, e) {
    if (data === null) {
      setTempValu({
        purchaseOrderID: 0,
        purchaseOrderNumber: ''
      });
      setTableData([]);
      setGoodsReceiveNote({
        ...goodsReceiveNote,
        purchaseNumberID: 0,
        requisitionID: 0,
        invoiceNumber: '',
        invoiceDate: moment(new Date()).format('YYYY-MM-DD'),
        paymentDueDate: moment(new Date()).format('YYYY-MM-DD'),
        gtnNumberID: 0
      });
      return;
    }
    let list = [...purchaseOrder];
    setTempValu(data);
    const result = list.find(
      e => e.purchaseOrderNumber === data.purchaseOrderNumber
    );

    if (!result) {
      alert.error('Selected PO Number is invalid.');
      return;
    }

    setTableData([]);
    setSelectedOptions([]);
    setGoodsReceiveNote({
      ...goodsReceiveNote,
      purchaseNumberID: result.purchaseOrderID,
      requisitionID: 0,
      invoiceNumber: '',
      invoiceDate: moment(new Date()).format('YYYY-MM-DD'),
      paymentDueDate: moment(new Date()).format('YYYY-MM-DD'),
      gtnNumberID: 0
    });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={() => navigate('/app/goodsReceiveNote/listing')}
          />
        </Grid>
      </Grid>
    );
  }

  const handleCheckboxChange = (reqIndex, itemIndex) => {
    if (goodsReceiveNote.grnType === PO || goodsReceiveNote.grnType === DPO) {
      if (!goodsReceiveNote.invoiceNumber || !goodsReceiveNote.invoiceDate) {
        alert.error('Invoice Number and Invoice Date are required');
        return;
      }
    }

    const updatedData = [...tableData];
    const item = updatedData[reqIndex].items[itemIndex];
    item.qcStatus = !item.qcStatus;
    if (item.qcStatus) {
      item.actionQty = item.receivedQTY;
    } else {
      item.actionQty = '';
      item.additionalData = [];
      item.expanded = false;
    }
    setTableData(updatedData);
  };

  const toggleExpand = (reqIndex, itemIndex) => {
    const updatedData = [...tableData];
    updatedData[reqIndex].items[itemIndex].expanded = !updatedData[reqIndex]
      .items[itemIndex].expanded;
    setTableData(updatedData);
  };

  const handleAddAdditionalData = (
    reqIndex,
    itemIndex,
    type,
    qty,
    unitPrice,
    cost,
    sku
  ) => {
    if (!type || isNaN(qty) || qty <= 0) {
      alert.error('Please enter a valid quantity.');
      return;
    }
    type = type || 1;

    const updatedData = [...tableData];
    if (!updatedData[reqIndex] || !updatedData[reqIndex].items[itemIndex]) {
      alert.error('Invalid requisition or item index.');
      return;
    }

    const item = updatedData[reqIndex].items[itemIndex];
    const remainingQty =
      item.receivedQTY -
      (item.actionQty || 0) -
      item.additionalData.reduce((sum, data) => sum + data.qty, 0);

    if (
      qty >
      item.receivedQTY -
      item.additionalData.reduce((sum, data) => sum + data.qty, 0)
    ) {
      alert.error(`Qty cannot exceed remaining quantity (${remainingQty})`);
      return;
    }

    const existingDataIndex = item.additionalData.findIndex(
      data => data.type === type
    );
    if (existingDataIndex >= 0) {
      alert.error(`Action type already exists.`);
      return;
    }

    const lineDiscountTotal = parseFloat(item.discountAmount || 0);
    const lineVatTotal = parseFloat(item.vatAmount || 0);
    const totalReceived = parseFloat(item.receivedQTY || 0);
    const proportionalDiscount =
      totalReceived > 0
        ? lineDiscountTotal * (parseFloat(qty || 0) / totalReceived)
        : 0;
    const proportionalVat =
      totalReceived > 0
        ? lineVatTotal * (parseFloat(qty || 0) / totalReceived)
        : 0;
    const rowDiscount = proportionalDiscount;
    const rowVat = proportionalVat;
    let totalPrice = (unitPrice * qty) + cost + rowVat - rowDiscount;

    item.additionalData = item.additionalData || [];
    item.additionalData.push({
      type,
      qty,
      unitPrice,
      cost,
      discount: rowDiscount,
      vat: rowVat,
      totalPrice,
      sku: item.sku,
      fromWarehouseID: item.fromWarehouseID,
      toWarehouseID: item.toWarehouseID
    });

    // Clear inputs so the next action can have its own separate additional cost
    item.actionQty = '';
    item.cost = 0;
    item.expanded = true;
    setTableData(updatedData);
  };

  const handleDeleteAdditionalData = (reqIndex, itemIndex, type) => {
    const updatedData = [...tableData];
    const item = updatedData[reqIndex].items[itemIndex];

    const deletedEntry = item.additionalData.find(data => data.type === type);

    if (deletedEntry) {
      const qtyToRestore = parseFloat(deletedEntry.qty) || 0;
      const currentActionQty = parseFloat(item.actionQty) || 0;

      item.actionQty = currentActionQty + qtyToRestore;
    }

    item.additionalData = item.additionalData.filter(
      data => data.type !== type
    );
    setTableData(updatedData);
  };

  const searchValidationSchema = Yup.object().shape({
    groupID: Yup.number()
      .required('Group is required')
      .min(1, 'Group is required'),
    factoryID: Yup.number()
      .required('Factory is required')
      .min(1, 'Factory is required'),
    receivedDate: Yup.date()
      .required('Received Date is required')
      .nullable(),
    grnType: Yup.number()
      .required('GRN Type is required')
      .min(1, 'GRN Type is required'),
    purchaseNumberID: Yup.number().when('grnType', {
      is: PO,
      then: Yup.number()
        .required('PO Number is required')
        .min(1, 'PO Number is required'),
      otherwise: Yup.number().notRequired()
    }),
    warehouseID: Yup.number().when('grnType', {
      is: DGRN,
      then: Yup.number()
        .required('Warehouse is required')
        .min(1, 'Warehouse is required'),
      otherwise: Yup.number().notRequired()
    }),
    gtnNumberID: Yup.number().when('grnType', {
      is: DGRN,
      then: Yup.number()
        .required('GTN Number is required')
        .min(1, 'GTN Number is required'),
      otherwise: Yup.number().notRequired()
    }),
    requisitionID: Yup.array()
      .nullable()
      .when('grnType', {
        is: PO,
        then: Yup.array()
          .of(Yup.number().required('Requisition Number is required'))
          .min(1, 'Requisition Number is required')
          .required('Requisition Number is required'),
        otherwise: Yup.array().nullable()
      })
  });

  const handleReceivedQtyChange = (reqIndex, itemIndex, value) => {
    const updatedData = [...tableData];
    const item = updatedData[reqIndex].items[itemIndex];
    const receivedQty = parseFloat(value) || 0;

    if (receivedQty > item.requestedQTY) {
      alert.error('Received quantity cannot exceed PO quantity.');
      return;
    }

    item.receivedQTY = receivedQty;
    item.actionQty = receivedQty;
    item.netAmount = (
      parseFloat(item.unitPrice || 0) * parseFloat(item.receivedQTY || 0) -
      item.discountAmount
    ).toFixed(2);
    setTableData(updatedData);
  };

  const handleActionQtyChange = (reqIndex, itemIndex, value) => {
    const updatedData = [...tableData];
    const item = updatedData[reqIndex].items[itemIndex];
    const actionQty = parseFloat(value) || 0;
    const remainingQty =
      item.receivedQTY -
      item.additionalData.reduce((sum, data) => sum + data.qty, 0);

    if (actionQty > item.receivedQTY) {
      alert.error('Action quantity cannot exceed received quantity.');
      return;
    }

    if (actionQty > remainingQty) {
      alert.error('Action quantity cannot exceed remaining quantity.');
      return;
    }

    item.actionQty = actionQty;
    setTableData(updatedData);
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <CardContent style={{ marginBottom: '1rem' }}>
          <Card>
            <Box>
              <Formik
                initialValues={goodsReceiveNote}
                validationSchema={searchValidationSchema}
                enableReinitialize
                onSubmit={getGoodsReceiveNoteDetails}
              >
                {({
                  errors,
                  handleBlur,
                  handleSubmit,
                  touched,
                  values,
                  setFieldValue
                }) => (
                  <form onSubmit={handleSubmit}>
                    <CardContent>
                      <Box mt={0}>
                        <CardHeader
                          title={cardTitle(title)}
                        />
                        <Grid container spacing={4}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.groupID}
                              variant="outlined"
                              id="groupID"
                              size="small"
                              disabled={
                                isUpdate || !permissionList.isGroupFilterEnabled
                              }
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.factoryID && errors.factoryID
                              )}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={goodsReceiveNote.factoryID}
                              variant="outlined"
                              size="small"
                              id="factoryID"
                              disabled={
                                !permissionList.isFactoryFilterEnabled ||
                                isUpdate
                              }
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="grnType">
                              GRN Type *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.grnType && errors.grnType)}
                              fullWidth
                              helperText={touched.grnType && errors.grnType}
                              name="grnType"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={goodsReceiveNote.grnType}
                              variant="outlined"
                              id="grnType"
                              size="small"
                              disabled={isUpdate}
                            >
                              <MenuItem value={0}>--Select GRN Type--</MenuItem>
                              {/* <MenuItem value={1}>Direct GRN</MenuItem> */}
                              {/* <MenuItem value={2}>Purchase Order</MenuItem> */}
                              <MenuItem value={3}>Direct Purchase Order
                              </MenuItem>
                            </TextField>
                          </Grid>
                        </Grid>
                        {goodsReceiveNote.grnType === 0 ? null : goodsReceiveNote.grnType === PO ? (
                          <div>
                            <Grid container spacing={4}>
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="purchaseNumberID">
                                  PO Number *
                                </InputLabel>
                                <Autocomplete
                                  options={
                                    purchaseOrder === undefined ||
                                      purchaseOrder.length <= 0
                                      ? [
                                        {
                                          purchaseOrderNumber: '',
                                          purchaseOrderID: 0
                                        }
                                      ]
                                      : purchaseOrder
                                  }
                                  size={'small'}
                                  getOptionLabel={option =>
                                    option.purchaseOrderNumber
                                      ? option.purchaseOrderNumber
                                      : ''
                                  }
                                  onChange={(e, value) =>
                                    handleSearchDropdownPONumber(value, e)
                                  }
                                  value={TempValu}
                                  InputProps={{
                                    readOnly: isUpdate
                                  }}
                                  renderInput={params => (
                                    <TextField
                                      {...params}
                                      error={Boolean(
                                        touched.purchaseNumberID &&
                                        errors.purchaseNumberID
                                      )}
                                      helperText={
                                        touched.purchaseNumberID &&
                                        errors.purchaseNumberID
                                      }
                                      fullWidth
                                      size="small"
                                      autoFocus
                                      variant="outlined"
                                      placeholder="--Select PO Number--"
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="requisitionID">
                                  Requisition Number *
                                </InputLabel>
                                <CustomMultiSelect
                                  error={Boolean(
                                    touched.requisitionID &&
                                    errors.requisitionID
                                  )}
                                  helperText={
                                    touched.requisitionID &&
                                    errors.requisitionID
                                  }
                                  items={requisitions}
                                  getOptionLabel={getOptionLabel}
                                  getOptionDisabled={getOptionDisabled}
                                  selectedValues={selectedOptions}
                                  selectAllLabel="Select all"
                                  onToggleOption={selectedOptionsValue => {
                                    handleToggleOption(selectedOptionsValue);
                                    const ids = (selectedOptionsValue || []).map(o => parseInt(o.value));
                                    setFieldValue('requisitionID', ids);
                                  }}
                                  onClearOptions={() => {
                                    setSelectedOptions([]);
                                    setFieldValue('requisitionID', []);
                                  }}
                                  onSelectAll={isSelected => {
                                    handleSelectAll(isSelected);
                                    const ids = isSelected ? requisitions.map(r => parseInt(r.value)) : [];
                                    setFieldValue('requisitionID', ids);
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </div>
                        ) : goodsReceiveNote.grnType === DGRN ? (
                          <div>
                            <Grid container spacing={4}>
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="warehouseID">
                                  Warehouse *
                                </InputLabel>
                                <TextField
                                  select
                                  error={Boolean(
                                    touched.warehouseID && errors.warehouseID
                                  )}
                                  helperText={
                                    touched.warehouseID && errors.warehouseID
                                  }
                                  fullWidth
                                  name="warehouseID"
                                  size="small"
                                  onChange={e => handleChange(e)}
                                  value={goodsReceiveNote.warehouseID}
                                  variant="outlined"
                                >
                                  <MenuItem value="0">
                                    --Select Warehouse--
                                  </MenuItem>
                                  {generateDropDownMenu(warehouse)}
                                </TextField>
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="gtnNumberID">
                                  GTN Number *
                                </InputLabel>
                                <TextField
                                  select
                                  error={Boolean(
                                    touched.gtnNumberID && errors.gtnNumberID
                                  )}
                                  fullWidth
                                  helperText={
                                    touched.gtnNumberID && errors.gtnNumberID
                                  }
                                  name="gtnNumberID"
                                  onBlur={handleBlur}
                                  onChange={e => handleChange(e)}
                                  value={goodsReceiveNote.gtnNumberID}
                                  variant="outlined"
                                  id="gtnNumberID"
                                  size="small"
                                >
                                  <MenuItem value="0">
                                    --Select GTN Number--
                                  </MenuItem>
                                  {generateDropDownMenu(gtnNumber)}
                                </TextField>
                              </Grid>
                            </Grid>
                          </div>
                        ) : (
                          <div>
                            <Grid container spacing={4}>
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="dpoNumberID">
                                  Direct PO Number *
                                </InputLabel>
                                <TextField
                                  select
                                  error={Boolean(
                                    touched.dpoNumberID && errors.dpoNumberID
                                  )}
                                  fullWidth
                                  helperText={
                                    touched.dpoNumberID && errors.dpoNumberID
                                  }
                                  name="dpoNumberID"
                                  onBlur={handleBlur}
                                  onChange={e => handleChange(e)}
                                  value={goodsReceiveNote.dpoNumberID}
                                  variant="outlined"
                                  id="dpoNumberID"
                                  size="small"
                                >
                                  <MenuItem value="0">
                                    --Select Direct PO Number--
                                  </MenuItem>
                                  {generateDropDownMenu(dpoNumber)}
                                </TextField>
                              </Grid>
                            </Grid>
                          </div>
                        )}
                        <Box display="flex" flexDirection="row-reverse" p={2}>
                          {isUpdate ? (
                            <Button
                              color="primary"
                              variant="contained"
                              size="small"
                              disabled={!isEditIcon}
                            >
                              Update
                            </Button>
                          ) : (
                            <Button
                              color="primary"
                              variant="contained"
                              size="small"
                              type="submit"
                            >
                              Search
                            </Button>
                          )}
                        </Box>
                      </Box>
                    </CardContent>
                  </form>
                )}
              </Formik>
            </Box>
          </Card>
          <Card mt={3}>
            <Box>
              <Formik
                initialValues={{
                  tableData: tableData
                }}
                onSubmit={handleSave}
              >
                {({ values, errors, touched, handleChange, handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    {tableData.length !== 0 ? (
                      <Box>
                        <CardContent>
                          <Grid container spacing={3} alignItems="center">
                            <Grid
                              item
                              md={3}
                              xs={12}
                              style={{
                                display:
                                  goodsReceiveNote.grnType !== 1
                                    ? 'block'
                                    : 'none'
                              }}
                            >
                              <InputLabel shrink id="invoiceDate">
                                Invoice Date *
                              </InputLabel>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  error={Boolean(
                                    touched.invoiceDate && errors.invoiceDate
                                  )}
                                  helperText={
                                    touched.invoiceDate && errors.invoiceDate
                                  }
                                  autoOk
                                  fullWidth
                                  variant="inline"
                                  format="dd/MM/yyyy"
                                  inputVariant="outlined"
                                  name="invoiceDate"
                                  id="invoiceDate"
                                  size="small"
                                  value={
                                    goodsReceiveNote.invoiceDate
                                      ? new Date(goodsReceiveNote.invoiceDate)
                                      : null
                                  }
                                  onChange={date =>
                                    handleDateChange('invoiceDate', date)
                                  }
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date'
                                  }}
                                  InputProps={{ readOnly: isUpdate }}
                                  disabled={isUpdate}
                                  disableFuture
                                />
                              </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid
                              item
                              md={3}
                              xs={12}
                              style={{
                                display:
                                  goodsReceiveNote.grnType !== 1
                                    ? 'block'
                                    : 'none'
                              }}
                            >
                              <InputLabel shrink id="invoiceNumber">
                                Invoice Number *
                              </InputLabel>
                              <TextField
                                fullWidth
                                error={Boolean(
                                  touched.invoiceNumber && errors.invoiceNumber
                                )}
                                helperText={
                                  touched.invoiceNumber && errors.invoiceNumber
                                }
                                name="invoiceNumber"
                                onChange={e =>
                                  setGoodsReceiveNote(prevState => ({
                                    ...prevState,
                                    invoiceNumber: e.target.value
                                  }))
                                }
                                value={goodsReceiveNote.invoiceNumber}
                                variant="outlined"
                                size="small"
                                InputProps={{
                                  readOnly: isUpdate
                                }}
                              />
                            </Grid>
                            <Grid
                              item
                              md={3}
                              xs={12}
                              style={{
                                display:
                                  goodsReceiveNote.grnType !== 1
                                    ? 'block'
                                    : 'none'
                              }}
                            >
                              <InputLabel shrink id="netAmount">
                                Invoice Net Amount
                              </InputLabel>
                              <TextField
                                fullWidth
                                name="netAmount"
                                onChange={e => {
                                  let value = e.target.value.replace(
                                    /[^0-9.]/g,
                                    ''
                                  );
                                  const parts = value.split('.');
                                  if (parts.length > 1) {
                                    parts[1] = parts[1].slice(0, 2);
                                    e.target.value =
                                      parts.length > 1
                                        ? `${parts[0]}.${parts[1]}`
                                        : parts[0];
                                  }
                                  handleChange(e);
                                }}
                                error={Boolean(
                                  touched.netAmount && errors.netAmount
                                )}
                                helperText={
                                  touched.netAmount && errors.netAmount
                                }
                                onKeyDown={e => {
                                  const allowedKeys = [
                                    'Backspace',
                                    'Delete',
                                    'ArrowLeft',
                                    'ArrowRight',
                                    'Tab'
                                  ];
                                  if (
                                    e.key === '.' &&
                                    e.target.value.includes('.')
                                  ) {
                                    e.preventDefault();
                                  }
                                  if (
                                    !/^\d$/.test(e.key) &&
                                    !allowedKeys.includes(e.key) &&
                                    e.key !== '.'
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={goodsReceiveNote.netAmount}
                                variant="outlined"
                                size="small"
                                InputProps={{
                                  readOnly: isUpdate
                                }}
                              />
                            </Grid>
                            <Grid
                              item
                              md={3}
                              xs={12}
                              container
                              alignItems="center"
                            >
                              <Grid item xs={6}>
                                <InputLabel shrink id="isCredit">
                                  If Credit *
                                </InputLabel>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                display="flex"
                                justifyContent="center"
                              >
                                <Switch
                                  checked={goodsReceiveNote.isCredit}
                                  onChange={e => handleSwitchChange(e)}
                                  name="isCredit"
                                  color="primary"
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3} alignItems="center">
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="paymentDueDate">
                                Payment Due Date
                              </InputLabel>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  autoOk
                                  fullWidth
                                  variant="inline"
                                  format="dd/MM/yyyy"
                                  inputVariant="outlined"
                                  name="paymentDueDate"
                                  id="paymentDueDate"
                                  size="small"
                                  value={
                                    goodsReceiveNote.paymentDueDate
                                      ? new Date(
                                        goodsReceiveNote.paymentDueDate
                                      )
                                      : null
                                  }
                                  onChange={date => {
                                    if (date) {
                                      handleDateChange('paymentDueDate', date);
                                    }
                                  }}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date'
                                  }}
                                  InputProps={{ readOnly: isUpdate }}
                                  disabled={
                                    !goodsReceiveNote.isCredit || isUpdate
                                  }
                                />
                              </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="receivedDate">
                                Received Date *
                              </InputLabel>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  error={Boolean(
                                    touched.receivedDate && errors.receivedDate
                                  )}
                                  helperText={
                                    touched.receivedDate && errors.receivedDate
                                  }
                                  autoOk
                                  fullWidth
                                  variant="inline"
                                  format="dd/MM/yyyy"
                                  inputVariant="outlined"
                                  name="receivedDate"
                                  id="receivedDate"
                                  size="small"
                                  value={
                                    goodsReceiveNote.receivedDate
                                      ? new Date(goodsReceiveNote.receivedDate)
                                      : null
                                  }
                                  onChange={date =>
                                    handleDateChange('receivedDate', date)
                                  }
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date'
                                  }}
                                  InputProps={{ readOnly: isUpdate }}
                                  disabled={isUpdate}
                                  disableFuture
                                />
                              </MuiPickersUtilsProvider>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Box>
                    ) : null}
                    {tableData.length !== 0 ? (
                      <Paper
                        className={classes.formSection}
                        sx={{
                          padding: 3,
                          borderRadius: 3,
                          border: '1px solid #000000ff',
                          backgroundColor: '#f9f9f9',
                          boxShadow: 3
                        }}
                      >
                        {tableData.map((requisition, reqIndex) => (
                          <Box
                            key={reqIndex}
                            mb={3}
                            border="1px solid #000000ff"
                            margin={2}
                            borderRadius={5}
                            p={2}
                            sx={{ boxShadow: 1, backgroundColor: '#fff' }}
                          >
                            <Box
                              display="flex"
                              justifyContent="flex-start"
                              alignItems="center"
                            >
                              <Typography
                                variant="h6"
                                sx={{ fontWeight: 'bold', color: '#1976d2' }}
                              >
                                <Chip
                                  label={
                                    goodsReceiveNote.grnType === DPO
                                      ? `DPO No: ${requisition.dpoNumber}`
                                      : `Req. No: ${requisition.requisitionNumber}`
                                  }
                                  className={classes.sectionBadge}
                                />
                              </Typography>
                            </Box>
                            <br />
                            <TableContainer
                              component={Paper}
                              border="1px solid #000000ff"
                            >
                              <Table>
                                <TableHead className={classes.tableHeader}>
                                  <TableRow>
                                    {[
                                      goodsReceiveNote.grnType === PO
                                        ? 'PO Qty'
                                        : goodsReceiveNote.grnType === DGRN
                                          ? 'DGRN Qty'
                                          : goodsReceiveNote.grnType === DPO
                                            ? 'DPO Qty'
                                            : 'Qty',
                                      'QC Accepted',
                                      'Received Qty',
                                      'Action Type',
                                      'Action Qty',
                                      'Unit Price',
                                      'VAT',
                                      ...(goodsReceiveNote.grnType !== 1
                                        ? [/*'Discount',*/ 'Net Amount']
                                        : []),
                                      'Additional Cost',
                                      'Remaining Qty',
                                      ''
                                    ].map((header, index) => (
                                      <TableCell
                                        key={index}
                                        align="center"
                                        sx={{ fontWeight: 'bold' }}
                                      >
                                        {header}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {requisition.items.map((item, itemIndex) => (
                                    <React.Fragment key={itemIndex}>
                                      <TableRow
                                        className={classes.tableRow}
                                        sx={{
                                          backgroundColor:
                                            itemIndex % 2 === 0
                                              ? '#f5f5f5'
                                              : '#ffffff'
                                        }}
                                      >
                                        <TableCell
                                          colSpan={12}
                                          sx={{ textAlign: 'center', py: 2 }}
                                        >
                                          <Box
                                            display="flex"
                                            justifyContent="flex-start"
                                            alignItems="center"
                                          >
                                            <Typography
                                              variant="h6"
                                              sx={{
                                                fontWeight: 'bold',
                                                color: '#1976d2'
                                              }}
                                            >
                                              <Chip
                                                label={`SKU Name: ${item.sku}`}
                                                sx={{
                                                  padding: '8px',
                                                  borderRadius: '12px',
                                                  backgroundColor: '#e3f2fd',
                                                  fontWeight: 'bold',
                                                  fontSize: '1rem',
                                                  border: '1px solid #1976d2'
                                                }}
                                              />
                                            </Typography>
                                            {/* <Typography variant="h6" sx={{ fontWeight: "bold", color: "#1976d2" }}>
                                              <Chip
                                                label={`Supplier Name: ${item.supplierID}`}
                                                sx={{
                                                  padding: "8px",
                                                  borderRadius: "12px",
                                                  backgroundColor: "#e3f2fd",
                                                  fontWeight: "bold",
                                                  fontSize: "1rem",
                                                  border: "1px solid #1976d2",
                                                }}
                                              />
                                            </Typography> */}
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                      <TableRow
                                        className={classes.tableRow}
                                        hover
                                      >
                                        <TableCell align="right">
                                          {formatNumberWithThousandSeparators(
                                            item.requestedQTY.toFixed(2)
                                          )}
                                        </TableCell>
                                        <TableCell align="center">
                                          <Checkbox
                                            checked={item.qcStatus}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                reqIndex,
                                                itemIndex
                                              )
                                            }
                                            color="primary"
                                          />
                                        </TableCell>
                                        <TableCell align="right">
                                          <TextField
                                            fullWidth
                                            onChange={e => {
                                              let value = e.target.value.replace(
                                                /[^0-9.]/g,
                                                ''
                                              );
                                              const parts = value.split('.');
                                              if (parts.length > 1) {
                                                parts[1] = parts[1].slice(0, 2);
                                                value =
                                                  parts.length > 1
                                                    ? `${parts[0]}.${parts[1]}`
                                                    : parts[0];
                                              }
                                              handleReceivedQtyChange(
                                                reqIndex,
                                                itemIndex,
                                                value
                                              );
                                            }}
                                            value={formatNumberWithThousandSeparators(
                                              parseFloat(item.receivedQTY) || 0
                                            )}
                                            size="small"
                                            InputProps={{
                                              inputProps: {
                                                style: { textAlign: 'right' }
                                              },
                                              readOnly: !item.qcStatus
                                            }}
                                            sx={{ textAlign: 'right' }}
                                            variant="outlined"
                                          />
                                        </TableCell>
                                        <TableCell align="right">
                                          <TextField
                                            select
                                            id="actionType"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            value={item.actionType || 1}
                                            onChange={e => {
                                              const updatedData = [
                                                ...tableData
                                              ];
                                              updatedData[reqIndex].items[
                                                itemIndex
                                              ].actionType = e.target.value;
                                              setTableData(updatedData);
                                            }}
                                          >
                                            <MenuItem value={0}>
                                              --Select Action Type--
                                            </MenuItem>
                                            <MenuItem value={1}>
                                              Accepted
                                            </MenuItem>
                                            {/*{generateDropDownMenu(actions)}*/}
                                          </TextField>
                                        </TableCell>
                                        <TableCell align="right">
                                          <TextField
                                            fullWidth
                                            onChange={e => {
                                              let value = e.target.value.replace(
                                                /[^0-9.]/g,
                                                ''
                                              );
                                              const parts = value.split('.');
                                              if (parts.length > 1) {
                                                parts[1] = parts[1].slice(0, 2);
                                                value =
                                                  parts.length > 1
                                                    ? `${parts[0]}.${parts[1]}`
                                                    : parts[0];
                                              }
                                              handleActionQtyChange(
                                                reqIndex,
                                                itemIndex,
                                                value
                                              );
                                            }}
                                            disabled={!item.qcStatus}
                                            onKeyDown={e => {
                                              oneKeyDownAddDecimal(e);
                                            }}
                                            value={formatNumberWithThousandSeparators(
                                              parseFloat(item.actionQty) || 0
                                            )}
                                            size="small"
                                            InputProps={{
                                              inputProps: {
                                                style: { textAlign: 'right' }
                                              }
                                            }}
                                            className={classes.actionQtyField}
                                            sx={{ textAlign: 'right' }}
                                            variant="outlined"
                                          />
                                        </TableCell>
                                        {goodsReceiveNote.grnType === DGRN ? (
                                          <TableCell align="right">
                                            <TextField
                                              fullWidth
                                              onChange={e => {
                                                let value = e.target.value.replace(
                                                  /[^0-9.]/g,
                                                  ''
                                                );
                                                const parts = value.split('.');
                                                if (parts.length > 1) {
                                                  parts[1] = parts[1].slice(
                                                    0,
                                                    2
                                                  );
                                                  value =
                                                    parts.length > 1
                                                      ? `${parts[0]}.${parts[1]}`
                                                      : parts[0];
                                                }
                                                const updatedData = [
                                                  ...tableData
                                                ];
                                                const price =
                                                  parseFloat(value) || 0;
                                                updatedData[reqIndex].items[
                                                  itemIndex
                                                ].unitPrice = price;
                                                const rcvQty =
                                                  parseFloat(
                                                    updatedData[reqIndex].items[
                                                      itemIndex
                                                    ].receivedQTY
                                                  ) || 0;
                                                const disc =
                                                  parseFloat(
                                                    updatedData[reqIndex].items[
                                                      itemIndex
                                                    ].discountAmount
                                                  ) || 0;
                                                updatedData[reqIndex].items[
                                                  itemIndex
                                                ].netAmount = (
                                                  price * rcvQty -
                                                  disc
                                                ).toFixed(2);
                                                setTableData(updatedData);
                                              }}
                                              value={formatNumberWithThousandSeparators(
                                                parseFloat(item.unitPrice) || 0
                                              )}
                                              size="small"
                                              InputProps={{
                                                inputProps: {
                                                  style: { textAlign: 'right' }
                                                }
                                              }}
                                              sx={{ textAlign: 'right' }}
                                              variant="outlined"
                                            />
                                          </TableCell>
                                        ) : (
                                          <>
                                            <TableCell
                                              align="right"
                                              className={classes.amountCell}
                                            >
                                              {formatNumberWithThousandSeparators(
                                                parseFloat(
                                                  item.unitPrice || 0.0
                                                ).toFixed(2)
                                              )}
                                            </TableCell>
                                            <TableCell
                                              align="right"
                                              className={classes.amountCell}
                                            >
                                              {formatNumberWithThousandSeparators(
                                                parseFloat(
                                                  item.vatAmount || 0.0
                                                ).toFixed(2)
                                              )}
                                            </TableCell>
                                            {/* <TableCell
                                              align="right"
                                              className={classes.discountCell}
                                            >
                                              {formatNumberWithThousandSeparators(
                                                parseFloat(
                                                  item.discountAmount || 0.0
                                                ).toFixed(2)
                                              )}
                                            </TableCell> */}
                                            <TableCell
                                              align="right"
                                              className={classes.amountCell}
                                            >
                                              {formatNumberWithThousandSeparators(
                                                parseFloat(
                                                  item.netAmount || 0.0
                                                ).toFixed(2)
                                              )}
                                            </TableCell>
                                          </>
                                        )}
                                        <TableCell
                                          align="right"
                                          className={classes.amountCell}
                                        >
                                          <TextField
                                            fullWidth
                                            onChange={e => {
                                              let value = e.target.value.replace(
                                                /[^0-9.]/g,
                                                ''
                                              );
                                              const parts = value.split('.');
                                              if (parts.length > 1) {
                                                parts[1] = parts[1].slice(0, 2);
                                                value =
                                                  parts.length > 1
                                                    ? `${parts[0]}.${parts[1]}`
                                                    : parts[0];
                                              }
                                              const updatedData = [
                                                ...tableData
                                              ];
                                              updatedData[reqIndex].items[
                                                itemIndex
                                              ].cost = parseFloat(value) || 0;
                                              setTableData(updatedData);
                                            }}
                                            value={formatNumberWithThousandSeparators(
                                              item.cost || 0
                                            )}
                                            size="small"
                                            InputProps={{
                                              inputProps: {
                                                style: { textAlign: 'right' }
                                              }
                                            }}
                                            sx={{ textAlign: 'right' }}
                                            variant="outlined"
                                          />
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          className={classes.remainingQtyCell}
                                        >
                                          {formatNumberWithThousandSeparators(
                                            item.receivedQTY -
                                            (item.actionQty || 0) -
                                            item.additionalData
                                              .reduce(
                                                (sum, data) => sum + data.qty,
                                                0
                                              )
                                              .toFixed(2)
                                          )}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          className={`${classes.actionCell} ${item.qcStatus
                                            ? classes.actionCellVisible
                                            : classes.actionCellHidden
                                            }`}
                                        >
                                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Button
                                              className={`${classes.modernButton} ${classes.successButton}`}
                                              startIcon={<AddIcon />}
                                              onClick={() => {
                                                handleAddAdditionalData(
                                                  reqIndex,
                                                  itemIndex,
                                                  item.actionType ===
                                                    undefined
                                                    ? 1
                                                    : parseInt(
                                                      item.actionType
                                                    ),
                                                  parseFloat(item.actionQty),
                                                  item.unitPrice === undefined
                                                    ? 0
                                                    : item.unitPrice,
                                                  item.cost === undefined
                                                    ? 0
                                                    : item.cost
                                                );
                                              }}
                                              color="primary"
                                              variant="contained"
                                              size="small"
                                            >
                                              ADD
                                            </Button>
                                            <IconButton
                                              onClick={() =>
                                                toggleExpand(
                                                  reqIndex,
                                                  itemIndex
                                                )
                                              }
                                              color="primary"
                                            >
                                              {item.expanded ? (
                                                <ArrowDropDownIcon />
                                              ) : (
                                                <ArrowDropUpIcon />
                                              )}
                                            </IconButton>
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell
                                          colSpan={12}
                                          sx={{
                                            paddingBottom: 0,
                                            paddingTop: 0
                                          }}
                                        >
                                          <Collapse
                                            in={item.expanded}
                                            timeout="auto"
                                            unmountOnExit
                                          >
                                            <Box
                                              sx={{
                                                margin: 2,
                                                padding: 2,
                                                border: '1px solid #e5e7eb',
                                                borderRadius: 8,
                                                backgroundColor: '#f9fafb'
                                              }}
                                            >
                                              {item.additionalData.length > 0
                                                && (
                                                  <Grid container spacing={1}>
                                                    <Grid item xs={12}>
                                                      <MaterialTable
                                                        title="Additional Data"
                                                        columns={[
                                                          {
                                                            title: 'SKU',
                                                            field: 'sku',
                                                            render: rowData =>
                                                              rowData.sku
                                                          },
                                                          {
                                                            title: 'Type',
                                                            field: 'type',
                                                            render: rowData =>
                                                              actions[
                                                              rowData.type
                                                              ]
                                                          },
                                                          {
                                                            title: 'Qty',
                                                            field: 'qty',
                                                            render: rowData =>
                                                              formatNumberWithThousandSeparators(
                                                                rowData.qty.toFixed(
                                                                  2
                                                                )
                                                              )
                                                          },
                                                          {
                                                            title: 'Unit Price',
                                                            field: 'unitPrice',
                                                            render: rowData =>
                                                              formatNumberWithThousandSeparators(
                                                                rowData.unitPrice.toFixed(
                                                                  2
                                                                )
                                                              )
                                                          },
                                                          /* {
                                                            title: 'Discount',
                                                            field: 'discount',
                                                            render: rowData =>
                                                              formatNumberWithThousandSeparators(
                                                                (
                                                                  rowData.discount ||
                                                                  0
                                                                ).toFixed(2)
                                                              )
                                                          }, */
                                                          {
                                                            title: 'VAT',
                                                            field: 'vat',
                                                            render: rowData =>
                                                              formatNumberWithThousandSeparators(
                                                                (
                                                                  rowData.vat ||
                                                                  0
                                                                ).toFixed(2)
                                                              )
                                                          },
                                                          // {
                                                          //   title:
                                                          //     'Additional Cost',
                                                          //   field: 'cost',
                                                          //   render: rowData =>
                                                          //     formatNumberWithThousandSeparators(
                                                          //       rowData.cost.toFixed(
                                                          //         2
                                                          //       )
                                                          //     )
                                                          // },
                                                          {
                                                            title: 'Total Price',
                                                            field: 'totalPrice',
                                                            // render: rowData => {
                                                            //   const base =
                                                            //     (rowData.unitPrice ||
                                                            //       0) *
                                                            //     (rowData.qty ||
                                                            //       0);
                                                            //   const disc =
                                                            //     rowData.discount ||
                                                            //     0;
                                                            //   const total =
                                                            //     base -
                                                            //     disc +
                                                            //     (rowData.cost ||
                                                            //       0);
                                                            //   return formatNumberWithThousandSeparators(
                                                            //     total.toFixed(2)
                                                            //   );
                                                            // }
                                                            render: rowData =>
                                                              formatNumberWithThousandSeparators(
                                                                rowData.totalPrice.toFixed(
                                                                  2
                                                                )
                                                              )
                                                          },
                                                          {
                                                            title: 'Actions',
                                                            field: 'actions',
                                                            render: rowData => (
                                                              <>
                                                                <IconButton
                                                                  onClick={() =>
                                                                    handleDeleteAdditionalData(
                                                                      reqIndex,
                                                                      itemIndex,
                                                                      rowData.type
                                                                    )
                                                                  }
                                                                  style={{
                                                                    color: 'red'
                                                                  }}
                                                                >
                                                                  <DeleteIcon />
                                                                </IconButton>
                                                              </>
                                                            )
                                                          }
                                                        ]}
                                                        data={[
                                                          ...item.additionalData
                                                        ]}
                                                        options={{
                                                          search: false,
                                                          paging: false,
                                                          toolbar: false,
                                                          headerStyle: {
                                                            backgroundColor:
                                                              '#eef2ff',
                                                            color: '#000',
                                                            fontWeight: 'bold'
                                                          },
                                                          rowStyle: (
                                                            rowData,
                                                            index
                                                          ) => ({
                                                            backgroundColor:
                                                              index % 2 === 0
                                                                ? '#ffffff'
                                                                : '#f9fafb'
                                                          })
                                                        }}
                                                      />
                                                    </Grid>
                                                  </Grid>
                                                )}
                                            </Box>
                                          </Collapse>
                                        </TableCell>
                                      </TableRow>

                                    </React.Fragment>
                                  ))}
                                  <TableRow>
                                    <TableCell colSpan={12}>
                                      {(tableData.some(req =>
                                        req.items.some(item =>
                                          Array.isArray(item.additionalData) &&
                                          item.additionalData.some(ad => String(ad.type || ad.actionType || '') === '1')
                                        ))) && (
                                          <Card mt={3} >
                                            <AccountEntries
                                              factoryID={goodsReceiveNote.factoryID}
                                              isCredit={goodsReceiveNote.isCredit}
                                              legerAccount={ledgerAccountsByRequisition[reqIndex]}
                                              setTransactions={entries => {
                                                const updated = [
                                                  ...transactionsByRequisition
                                                ];
                                                updated[reqIndex] = {
                                                  requisitionIndex: reqIndex,
                                                  entries
                                                };
                                                setTransactionsByRequisition(updated);
                                              }}
                                              setVarianceBalance={setVariance}
                                              netAmount={requisition.items.reduce((total, item) => {
                                                const itemAddedValue = (item.additionalData || [])
                                                  .filter(d => String(d.type) === '1') // Accepted only
                                                  .reduce((acc, d) => acc + (parseFloat(d.totalPrice) || 0), 0);
                                                return total + itemAddedValue;
                                              }, 0)}
                                              vatAmount={goodsReceiveNote.grnType === 3 ? requisition.items.reduce((total, item) => {
                                                const itemVat = (item.additionalData || [])
                                                  .filter(d => String(d.type) === '1')
                                                  .reduce((acc, d) => acc + (parseFloat(d.vat) || 0), 0);
                                                return total + itemVat;
                                              }, 0) : 0}
                                              vatAccount={vatAccount}
                                              tableLength={tableData}
                                              enableCreditSide={transactionsByRequisition[reqIndex]?.entries?.some(entry =>
                                                parseFloat(entry.debit || 0) > 0
                                              ) || false}
                                            />
                                          </Card>
                                        )}
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                        ))}

                        <Box display="flex" flexDirection="row-reverse" p={2}>
                          <Button
                            className={`${classes.modernButton} ${classes.primaryButton}`}
                            color="primary"
                            variant="contained"
                            size="small"
                            type="submit"
                            disabled={values.tableData.some(requisition =>
                              requisition.items.some(
                                item => item.additionalData.length === 0
                              )
                            )}
                          >
                            Save
                          </Button>
                          <span style={{ margin: '0 8px' }}></span>
                          <Button
                            className={`${classes.modernButton} ${classes.secondaryButton}`}
                            color="primary"
                            variant="contained"
                            size="small"
                            onClick={handleCancel}
                          >
                            Cancel
                          </Button>
                        </Box>
                      </Paper>
                    ) : null}
                  </form>
                )}
              </Formik>
            </Box>
          </Card>
        </CardContent>
      </Page>
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        classes={{ paper: classes.dialogPaper }}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle disableTypography>
          <Box className={classes.dialogTitle}>
            <Avatar className={classes.dialogIcon}>
              <InfoIcon />
            </Avatar>
            <Box>
              <Typography variant="h6">
                {isCancel ? 'Confirm Cancel' : 'Goods Received Note'}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {dialogContent}
              </Typography>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box className={classes.summarySection} mb={2}>
            <Grid container spacing={2}>
              <Grid item xs={6} md={3}>
                <Typography variant="caption" color="textSecondary">
                  Group
                </Typography>
                <Typography variant="body1" style={{ fontWeight: 600 }}>
                  {getGroupNameById(goodsReceiveNote.groupID)}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="caption" color="textSecondary">
                  Factory
                </Typography>
                <Typography variant="body1" style={{ fontWeight: 600 }}>
                  {FactoryList[goodsReceiveNote.factoryID]}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="caption" color="textSecondary">
                  GRN Type
                </Typography>
                <Typography variant="body1" style={{ fontWeight: 600 }}>
                  {title.replace('Goods Received Note - ', '')}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="caption" color="textSecondary">
                  Received Date
                </Typography>
                <Typography variant="body1" style={{ fontWeight: 600 }}>
                  {goodsReceiveNote.receivedDate}
                </Typography>
              </Grid>
              {goodsReceiveNote.grnType !== 1 && (
                <>
                  <Grid item xs={6} md={3}>
                    <Typography variant="caption" color="textSecondary">
                      Invoice No.
                    </Typography>
                    <Typography variant="body1" style={{ fontWeight: 600 }}>
                      {goodsReceiveNote.invoiceNumber || '-'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography variant="caption" color="textSecondary">
                      Invoice Date
                    </Typography>
                    <Typography variant="body1" style={{ fontWeight: 600 }}>
                      {goodsReceiveNote.invoiceDate || '-'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography variant="caption" color="textSecondary">
                      Net Amount
                    </Typography>
                    <Typography variant="body1" className={classes.amountCell}>
                      {formatNumberWithThousandSeparators(
                        (goodsReceiveNote.netAmount || 0).toString()
                      )}
                    </Typography>
                  </Grid>
                  {/* <Grid item xs={6} md={3}>
                    <Typography variant="caption" color="textSecondary">
                      Gross Amount
                    </Typography>
                    <Typography variant="body1" className={classes.amountCell}>
                      {formatNumberWithThousandSeparators(
                        (goodsReceiveNote.grossAmount || 0).toString()
                      )}
                    </Typography>
                  </Grid> */}
                </>
              )}
            </Grid>
          </Box>

          <Box>
            <Typography variant="subtitle1" gutterBottom>
              Summary of Items
            </Typography>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead className={classes.tableHeader}>
                  <TableRow>
                    <TableCell>Requisition/DPO</TableCell>
                    <TableCell>SKU</TableCell>
                    <TableCell align="right">Qty</TableCell>
                    {goodsReceiveNote.grnType !== 1 && (
                      <>
                        <TableCell align="right">Unit Price</TableCell>
                        <TableCell align="right">Net Amount</TableCell>
                      </>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.slice(0, 5).map((req, rIdx) =>
                    req.items.slice(0, 3).map((it, iIdx) => (
                      <TableRow
                        key={`${rIdx}-${iIdx}`}
                        className={classes.tableRow}
                      >
                        <TableCell>
                          {goodsReceiveNote.grnType === DPO
                            ? req.dpoNumber || '-'
                            : req.requisitionNumber || '-'}
                        </TableCell>
                        <TableCell>{it.sku}</TableCell>
                        <TableCell align="right">
                          {formatNumberWithThousandSeparators(
                            parseFloat(it.receivedQTY || 0).toFixed(2)
                          )}
                        </TableCell>
                        {goodsReceiveNote.grnType !== 1 && (
                          <>
                            <TableCell
                              align="right"
                              className={classes.amountCell}
                            >
                              {formatNumberWithThousandSeparators(
                                parseFloat(it.unitPrice || 0).toFixed(2)
                              )}
                            </TableCell>
                            <TableCell
                              align="right"
                              className={classes.amountCell}
                            >
                              {formatNumberWithThousandSeparators(
                                parseFloat(it.netAmount || 0).toFixed(2)
                              )}
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {tableData.length > 5 && (
              <Box mt={1}>
                <Typography variant="caption" color="textSecondary">
                  and {tableData.length - 5} more requisition groups…
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          {isCancel ? (
            <>
              <Button
                onClick={handleDialogClose}
                color="primary"
                className={classes.modernButton}
                disabled={isSubmitting}
              >
                No
              </Button>
              <Button
                onClick={dialogAction}
                color="primary"
                variant="contained"
                className={`${classes.modernButton} ${classes.secondaryButton}`}
                autoFocus
                disabled={isSubmitting}
              >
                Yes, Cancel
              </Button>
            </>
          ) : (
            <>
              <Button
                onClick={handleDialogClose}
                color="primary"
                className={classes.modernButton}
                disabled={isSubmitting}
              >
                Back
              </Button>
              <Button
                onClick={dialogAction}
                color="primary"
                variant="contained"
                className={`${classes.modernButton} ${classes.primaryButton}`}
                autoFocus
                disabled={isSubmitting}
              >
                Save
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
